import { initialTheme } from '@/store/theme'
import cssVars from 'css-vars-ponyfill'

export const polishParameter = parameter => {
  const jsonIdentifiers = ['[', ']', '{', '}']
  if (typeof parameter === 'boolean') {
    return parameter
  } else if (jsonIdentifiers.includes(parameter.substring(0, 1))) {
    return JSON.parse(parameter)
  } else if (parameter === 'true' || parameter === 'false') {
    return parameter === 'true' // returns it as boolean instead of string
  } else if (parameter.includes(',')) {
    // when we have an array past in as comma-separated string
    return parameter.split(',').map(s => s.trim()) // trim off any starting/trailing spaces
  } else {
    return parameter
  }
}

export const extractUrlThemeParameters = (parameters) => {
  const themeSettings = {}
  for (let element in parameters) {
    if (element.includes('theme')) {
      // Can we find the passed in theme_property in our theme_module in store?
      const isDefinedThemeProperty = getNestedObjectValue(element.replace('theme_', '').replace('_', '.'), initialTheme())
      if (isDefinedThemeProperty) {
        let parts = element.split('_') // element is a string with theme_element_property (theme_buttons_color)
        if (!themeSettings[parts[1]]) {
          themeSettings[parts[1]] = {}
        }
        themeSettings[parts[1]][parts[2]] = parameters[element]
      }
    }
  }
  return themeSettings
}

export function setThemeVariables (theme) {
  const html = document.getElementsByTagName('html')[0]
  const addOrStrip = theme.cashierbackground.color === '#ffffff' ? -5 : 20
  html.style.setProperty(`--bghover-color`, shadeColor(theme.cashierbackground.color, 20))
  html.style.setProperty(`--border-color`, shadeColor(theme.cashierbackground.color, -20))
  html.style.setProperty(`--button-hover-color`, shadeColor(theme.buttons.color, -20))
  html.style.setProperty(`--card-bg`, shadeColor(theme.cashierbackground.color, addOrStrip))
  html.style.setProperty(`--choosed-card-bg`, shadeColor(theme.cashierbackground.color, -10))
  if (theme.inputbackground.color === '#ffffff') {
    // 20% darker of white turns into a weird purple
    html.style.setProperty(`--dropdown-active-color`, '#f1f1f1')
  } else {
    html.style.setProperty(`--dropdown-active-color`, shadeColor(theme.inputbackground.color, -20))
  }

  let themeObj = {}
  const maxLength = 120
  Object.keys(theme).forEach(key => {
    const properties = theme[key]
    Object.keys(properties).forEach(prop => {
      themeObj[`--${key}-${prop}`] = theme[key][prop]
      html.style.setProperty(`--${key}-${prop}`, theme[key][prop])
    })
  })

  themeObj = {
    ...themeObj,
    ...{
      '--bghover-color': shadeColor(theme.cashierbackground.color, 20),
      '--border-color': shadeColor(theme.cashierbackground.color, -20),
      '--dropdown-active-color': shadeColor(theme.inputbackground.color, -20),
      '--button-hover-color': shadeColor(theme.buttons.color, -20),
      '--card-bg': shadeColor(theme.cashierbackground.color, addOrStrip),
      '--choosed-card-bg': shadeColor(theme.cashierbackground.color, -10)
    }
  }
  // isIE11() && setThemeStyleTagIE(themeObj)
  cssVars({
    // preserve: false,
    variables: themeObj,
    onlyLegacy: true,
    watch: true
  })
}

// https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
export const shadeColor = (color, percent): string => {
  var R = parseInt(color.substring(1, 3), 16)
  var G = parseInt(color.substring(3, 5), 16)
  var B = parseInt(color.substring(5, 7), 16)

  R = parseInt('' + R * (100 + percent) / 100)
  G = parseInt('' + G * (100 + percent) / 100)
  B = parseInt('' + B * (100 + percent) / 100)

  R = (R < 255) ? R : 255
  G = (G < 255) ? G : 255
  B = (B < 255) ? B : 255

  var RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16))
  var GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16))
  var BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16))

  return '#' + RR + GG + BB
}

// Allows you to pass in a string in dot-format: 'data.user.contactinformation.email' and get back the value for that nested property, if it exists.
function getNestedObjectValue (path, obj) {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : null
  }, obj || self)
}
